import { render, staticRenderFns } from "./ParserContent.vue?vue&type=template&id=563b858d"
import script from "./ParserContent.vue?vue&type=script&lang=js"
export * from "./ParserContent.vue?vue&type=script&lang=js"
import style0 from "./ParserContent.vue?vue&type=style&index=0&id=563b858d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports